import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import "./user-guide.scss";
import { getValue } from "@utils/lodash";
import NoAccessPage from "@components/common/NoAccess";
import Loader from "@components/common/Loader";
import {
  createEmailTemplate,
  createUserGuide,
  deleteEmailTemplate,
  getEmailTemplateKeys,
  getEmailTemplateTypes,
  getEmailTemplates,
  getSpecificEmailTemplate,
  getUserGuide,
  getUserGuideList,
  updateEmailTemplate,
  updateUserGuid,
} from "@services/email-template.service";
import { QueryRequestHelper } from "@_common/query-request-helper";
import { useNavigate } from "react-router-dom";
import Notfound from "@components/Not-Found";
import { formatText } from "@_common/format-text";
import PaginationPage from "@components/pagination/pagination";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import SearchHeader from "@components/common/SearchHeader";
// import EmailTemplateEditPopup from "./add-popup";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromHTML,
  convertFromRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import base64 from "base-64";
import { convertCurrentDate } from "@_common/date-helpers";
import FooterWrapper from "@components/common/FooterWrapper";
import ScrollableDataTable from "@components/ScrollableDatatable/index";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { tableStatusStyle } from "@_common/colors";
import MoreAdminSvgComponent from "../../../assets/svg-components/left-menu/more-admin";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import EmailTemplateEditPopup from "../EmailTemplate/add-popup";
import UserGuideEditPopup from "./add-popup";
import { clientAdminFileUpload } from "@services/client-list.service";
import { removeNullOrUndefinedProperties } from "@_common/text-helpers";
import SupportSvgComponent from "../../../assets/svg-components/support";
import NewWindowSvgComponent from "../../../assets/svg-components/new-window";
import { sanitizeInput } from "@_common/dompurify";

export default function UserGuide(props: any) {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const navigate = useNavigate();

  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [typeList, setTypeList] = useState([]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      //   getKeys(request.type);
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    try {
      let payload = {
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(true);
      let resp = await getUserGuideList(queryRequest);
      if (resp) {
        setTemplateList(
          getValue(resp, `data.user_guides`, []).map((item: object) => ({
            ...item,
            created_at: convertCurrentDate(getValue(item, `created_at`, "")),
          }))
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const [keysInfo, setKeys] = useState({});
  const getKeys = async (type: string) => {
    let payload = {
      type: type ? type : "EXECUTOR_REMAINDER_TEMPLATE",
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await getEmailTemplateKeys(queryRequest);
      if (resp) {
        setKeys(getValue(resp, `data`, {}));
      } else {
      }
    } catch (error) {}
  };

  const getTypes = async () => {
    try {
      let resp = await getEmailTemplateTypes("");
      if (resp) {
        setTypeList(
          getValue(resp, `data`, []).map((item: any) => ({
            value: item,
            label: formatText(item),
          }))
        );
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);

    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteEntity = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await deleteEmailTemplate(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) {}
  };
  /* -------------------------------------------------------------------------- */
  /*                                   Edit section                             */
  /* -------------------------------------------------------------------------- */

  const [editId, setEditId] = useState("");
  const handleEditEntity = async (obj: object) => {
    setEditId(getValue(obj, `id`, ""));
    setRequest({
      ...request,
      name: getValue(obj, `name`, ""),
      type: getValue(obj, `type`, ""),
      description: getValue(obj, `description`, ""),
      video_url: getValue(obj, `video_url`, ""),
      document: getValue(obj, `document`, ""),
    });
    setShowUpdatePopup(true);
  };

  const handleUpdate = async (editId: string, status: boolean) => {
    try {
      let resp = await updateEmailTemplate(editId, { status: status });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
      }
    } catch (error) {}
  };
  /* ---------------------------  Insert Modal  ----------------------------- */

  const [showUpdatePopup, setShowUpdatePopup] = useState(false);
  const handlePopup = () => {
    setShowUpdatePopup(!showUpdatePopup);
    setRequest({
      type: "video",
      name: "",
      description: "",
      video_url: "",
      document: "",
    });
  };

  const [request, setRequest] = useState<any>({
    type: "video",
    name: "",
    description: "",
    video_url: "",
    document: "",
  });
  const handleChangeText = (e: any) => {
    const { name, value } = e.target;
    setRequest({
      ...request,
      [name]: sanitizeInput(value),
    });
  };
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const onEditorStateChange: Function = (editorState: any) => {
    setEditorState(editorState);
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    try {
      let payload = {
        type: getValue(request, `type`, ""),
        name: getValue(request, `name`, ""),
        description: getValue(request, `description`, ""),
      };
      let updatedPayload =
        request.type === "video"
          ? { ...payload, video_url: getValue(request, `video_url`, "") }
          : { ...payload, document: getValue(request, `document.id`, "") };
      setSubmitLoading(true);
      if (editId) {
        let resp = await updateUserGuid(editId, updatedPayload);
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          setShowUpdatePopup(false);
          getData();
          setEditId("");
        } else {
          setSubmitLoading(false);
        }
      } else {
        let resp = await createUserGuide(
          removeNullOrUndefinedProperties(updatedPayload)
        );
        if (resp) {
          toast.success(getValue(resp, `message`, ""));
          setSubmitLoading(false);
          setShowUpdatePopup(false);
          getData();
        } else {
          setSubmitLoading(false);
        }
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Guide Type",
        accessor: "type",
        width: 150,
        Cell: ({ row }: any) => {
          return <>{formatText(getValue(row, `original.type`, ""))}</>;
        },
      },
      {
        Header: "Title",
        accessor: "name",
        width: 200,
      },
      {
        Header: "Description",
        accessor: "description",
        width: 400,
      },
      {
        Header: "Added on",
        accessor: "created_at",
        width: 200,
      },
      {
        Header: "Action",
        width: 160,
        Cell: ({ row }: any) => {
          return (
            // getValue(props, `permissions`, []).includes("update") && (
            <div className="ms-2">
              <img
                onClick={() => handleEditEntity(getValue(row, `original`, {}))}
                src="/images/edit.svg"
                className="img-fluid"
                style={{ height: "24px", width: "24px" }}
              />
            </div>
            // )
          );
        },
      },
    ],
    []
  );
  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {})
    ).map((item) => parseInt(item));
    let selectedIds =
      templateList.length > 0
        ? templateList.filter((_item: object, index: number) =>
            selectedIndexList.includes(index)
          )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, ""))
      );
    } else {
      setSelectedIDs([]);
    }
  };
  const rowClick = (obj: object) => {};
  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };

  const [uploadLoading, setUploadLoading] = useState(false);
  const handleUploadDocuments = async (e: any) => {
    Array.from(e).forEach(async (item: any) => {
      let formData = new FormData();
      formData.append("file", item);
      setUploadLoading(true);
      try {
        let resp = await clientAdminFileUpload(formData);
        if (resp) {
          setRequest({
            ...request,
            document: getValue(resp, `data`, {}),
          });
          e = null;
          setUploadLoading(false);
        } else {
          e = null;
          setUploadLoading(false);
        }
      } catch (error) {
        e = null;
        setUploadLoading(false);
      }
    });
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      <>
        <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="header-parent-icon-holder">
              <MoreAdminSvgComponent />
            </div>

            <div className="title-wrapper">
              <h6 className="dashbaord-wrapper__header-parent-title">Admin</h6>
              <h4 className="dashbaord-wrapper__header-title">User Guide</h4>
            </div>
          </div>
          <div className="d-flex align-items-center">
          
            <RightMenuHeaders
              //search
              isSearch={true}
              searchInput={search_text}
              showSearchTextbox={showSearchTextbox}
              toggleSearch={toggleSearch}
              toggleSearchClose={toggleSearchClose}
              handleChangeSearch={handleChangeSearch}
              isAdd={
                getValue(props, `permissions`, []).includes("update")
                  ? true
                  : false
              }
              add={
                getValue(props, `permissions`, []).includes("update")
                  ? "true"
                  : "false"
              }
              handleAddFun={() => handlePopup()}
              //Line Seperator of button
              lineSeperator={true}
            />
          </div>
        </div>

        {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "admin_general_user_guide"
        ) ? (
          <NoAccessPage />
        ) : (
          <section>
            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : getValue(templateList, `length`, 0) > 0 ? (
              <>
                <div className={`main-page-layout-wrapper`}>
                  <ScrollableDataTable
                    columns={columns}
                    data={templateList}
                    getTableState={getTableState}
                    rowClick={rowClick}
                    check={check}
                    selectedIDs={selectedIDs}
                    checkboxlogo
                    getTrProps={getTrProps}
                  />
                  <FooterWrapper
                    list={templateList}
                    totalCount={totalCount}
                    limit={limit}
                    page_no={page_no}
                    handleChangePagination={handleChangePagination}
                    handleChangeLimit={handleChangeLimit}
                  />
                </div>
              </>
            ) : (
              <>
                {Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
              </>
            )}
          </section>
        )}
      </>

      <UserGuideEditPopup
        showUpdatePopup={showUpdatePopup}
        setShowUpdatePopup={setShowUpdatePopup}
        // keysInfo={keysInfo}
        request={request}
        handleChangeText={handleChangeText}
        // editorState={editorState}
        // onEditorStateChange={onEditorStateChange}
        handleSubmit={handleSubmit}
        submitLoading={submitLoading}
        uploadLoading={uploadLoading}
        editId={editId}
        setEditId={setEditId}
        // typeList={typeList}
        setRequest={setRequest}
        // getKeys={getKeys}
        handleUploadDocuments={handleUploadDocuments}
      />
      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </DashboardLayout>
  );
}
